{
  "name": "desert",
  "ramps": {
    "ground": ["#9C7444", "#C79A5B", "#E0BE7C", "#F2DDA4"],
    "groundAlt": ["#A9824F", "#CDA566", "#E6C98C"],
    "water": ["#1E5C66", "#2F8F8A", "#6FC7B5", "#B5E8D8"],
    "rock": ["#5E3029", "#8C4A38", "#B5694A"],
    "dirt": ["#7A5A3A", "#9A764C", "#B99262"],
    "foliage": ["#4C5631", "#6A7340", "#8A8F4F"],
    "timber": ["#5A4030", "#7E5F45", "#A07C58"],
    "concrete": ["#7E5F45", "#B38B62", "#D9B48A"],
    "roof": ["#6B4A35", "#8A6446"],
    "uniformUS": ["#8A7350", "#B59B6E", "#D8C39A"],
    "uniformEnemy": ["#4F4436", "#6B5B45", "#8C7A5A"]
  },
  "haze": "#F6E7C1",
  "ambientNight": "#2A2447"
}
